import { siteConfig } from '@/mocks/home';

const steps = [
  {
    step: '01',
    title: '选择平台',
    desc: '根据您的设备选择Android或iOS版本下载',
    icon: 'ri-smartphone-line',
  },
  {
    step: '02',
    title: '下载安装包',
    desc: '点击下载按钮，等待安装包下载完成',
    icon: 'ri-download-cloud-2-line',
  },
  {
    step: '03',
    title: '一键安装',
    desc: '打开安装包，按照提示完成安装',
    icon: 'ri-install-line',
  },
  {
    step: '04',
    title: '注册登录',
    desc: '创建角色，开启你的征途之旅',
    icon: 'ri-user-star-line',
  },
];

export default function DownloadGuide() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            下载指引
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            三步下载，即刻开战
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Android与iOS双平台支持，安全正版，一键安装，无需复杂操作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {steps.map((item) => (
            <div key={item.step} className="relative text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-accent-500 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-background-50`}></i>
              </div>
              <span className="absolute top-0 right-4 text-5xl font-heading font-bold text-accent-100/60 leading-none select-none">
                {item.step}
              </span>
              <h3 className="text-base font-semibold text-foreground-950 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <div className="p-6 rounded-2xl bg-background-50 flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
              <i className="ri-android-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Android 用户</h3>
            <p className="text-sm text-foreground-600 mb-4">
              支持Android 7.0及以上系统，APK直接安装
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
              <span>版本 {siteConfig.version}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{siteConfig.fileSize}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{siteConfig.updateDate}</span>
            </div>
            <a
              href={siteConfig.androidDownloadUrl}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              下载 Android 版
            </a>
          </div>

          <div className="p-6 rounded-2xl bg-background-50 flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-apple-line text-2xl text-secondary-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">iOS 用户</h3>
            <p className="text-sm text-foreground-600 mb-4">
              支持iOS 13.0及以上系统，App Store直接下载
            </p>
            <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
              <span>版本 {siteConfig.version}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{siteConfig.fileSize}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{siteConfig.updateDate}</span>
            </div>
            <a
              href={siteConfig.iosDownloadUrl}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              下载 iOS 版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}